// extracted by mini-css-extract-plugin
module.exports = {"slider":"style-module--slider--3vCyi","swip_box":"style-module--swip_box--Sr_fP","text":"style-module--text--1u0x6"};